import { render, staticRenderFns } from "./ManageLostLeads.vue?vue&type=template&id=d1eb180c"
import script from "./ManageLostLeads.vue?vue&type=script&lang=ts"
export * from "./ManageLostLeads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports